<script lang="ts" setup>
interface Props {
  elements: string[]
  elementClass?: string
}

defineProps<Props>()

const isPdfPage = inject('isPdfPage', false)
</script>

<template>
  <ul class="list-inside list-disc" :class="{ 'm-0 p-0': isPdfPage }">
    <li
      v-for="element in elements"
      :key="element"
      :class="`pr-1.5 ${elementClass}`"
    >
      {{ element }}
    </li>
  </ul>
</template>
